const extra = {
  "it": {
"completion":"Completamento", "inProgressExperiences":"Esperienze in progress", "completedExperiences":"Esperienze completate",
"doneExperience":"Esperienza completata", "donePlace":"Luogo visitato", "doneRestaurant":"Ristorante visitato", "doneCity":"Città visitata", "doneCountry":"Nazione visitata", "markTodo":"Da fare",
"filters":"Filtri", "order":"Ordina", "editWishlist":"Modifica wishlist", "inviteIdentifier":"Username o email",
"copyUnavailable": "Il link è pronto. Premi Copia link per copiarlo.",
"declinedOk": "Invito rifiutato.",
"accepted": "Invito accettato. Trovi la wishlist in Il mio mondo.",
"removed": "Partecipante rimosso. La persona è stata informata con una notifica.",
"revokeBody": "Vuoi rimuovere questa persona dalla wishlist? Riceverà una notifica.",
"revokeTitle": "Revoca partecipazione",
"inviteSent": "Invito inviato. L’utente potrà accettare o rifiutare dalla notifica.",
"declined": "Invito rifiutato",
"pending": "In attesa di accettazione",
"direction": "Direzione",
"descending": "Decrescente",
"ascending": "Crescente",
"editCover": "Modifica copertina",
"desiredDate": "Quando vorrei andare",
"clearDate": "Rimuovi data",
"sort": "Ordina per",
"bySection": "Sezione",
"byPriority": "Priorità",
"byDate": "Data di visita",
"byName": "Nome",
"anyPriority": "Tutte le priorità",
"cover": "Copertina",
"chooseCover": "Scegli copertina",
"removeCover": "Rimuovi copertina",
"coverError": "Impossibile leggere la foto. Scegli un’immagine JPG, PNG o WebP.",
"participants": "Partecipanti",
"addParticipant": "Aggiungi partecipante",
"participantHelp": "Invita un utente: potrà modificare la wishlist solo dopo aver accettato.",
"editor": "Può modificare",
"viewer": "Sola lettura",
"linkHelp": "Chiunque abbia il link può vedere questa wishlist, senza modificarla. Non serve un account.",
"createLink": "Crea link",
"copyLink": "Copia link",
"copied": "Link copiato.",
"revokeLink": "Disattiva link",
"shareLink": "Condividi link",
"linkUnavailable": "Questo link non è disponibile o è stato disattivato.",
"noParticipants": "Nessun partecipante.",
"allowEdit": "Consenti modifiche",
    "subtitle": "Le idee per i tuoi prossimi viaggi, raccolte come vuoi tu.",
    "chooseKind": "Cosa vuoi aggiungere?",
    "manual": "Aggiungi manualmente",
    "address": "Indirizzo",
    "publicTitle": "Wishlist nel profilo pubblico",
    "publicHelp": "Seleziona le wishlist da mostrare a chi visita il tuo profilo. Tutti i loro elementi saranno visibili. Deselezionale per nasconderle.",
    "publicEmpty": "Crea una wishlist in Il mio mondo per poterla selezionare qui.",
    "publicShareHint": "Puoi mostrarla anche nel profilo pubblico, dalle impostazioni di condivisione del profilo.",
    "restaurant": "Ristorante",
    "country": "Nazione",
    "priority": "Priorità",
    "priorityHelp": "1 massima · 5 minima",
    "all": "Tutto",
    "search": "Cerca",
    "searchCountry": "Cerca una nazione",
    "noResults": "Nessun risultato.",
    "editItem": "Modifica elemento",
    "sections": "Sezioni",
    "items": "elementi",
    "item": "elemento",
    "countries": "Nazioni",
    "cities": "Città",
    "places": "Luoghi",
    "experiences": "Esperienze",
    "restaurants": "Ristoranti",
    "countryTrip": "La nazione sarà aggiunta come tappa nell’itinerario.",
    "empty": "Raccogli in ogni wishlist esperienze, luoghi, ristoranti, città e nazioni."
  },
  "en": {
"completion":"Completion", "inProgressExperiences":"Experiences in progress", "completedExperiences":"Completed experiences",
"doneExperience":"Experience completed", "donePlace":"Place visited", "doneRestaurant":"Restaurant visited", "doneCity":"City visited", "doneCountry":"Country visited", "markTodo":"To do",
"filters":"Filters", "order":"Sort", "editWishlist":"Edit wishlist", "inviteIdentifier":"Username or email",
"copyUnavailable": "Your link is ready. Press Copy link to copy it.",
"declinedOk": "Invitation declined.",
"accepted": "Invitation accepted. Find the wishlist in My world.",
"removed": "Participant removed. They have been notified.",
"revokeBody": "Remove this person from the wishlist? They will receive a notification.",
"revokeTitle": "Revoke participation",
"inviteSent": "Invitation sent. The user can accept or decline from the notification.",
"declined": "Invitation declined",
"pending": "Awaiting acceptance",
"direction": "Direction",
"descending": "Descending",
"ascending": "Ascending",
"editCover": "Edit cover",
"desiredDate": "When I would like to go",
"clearDate": "Remove date",
"sort": "Sort by",
"bySection": "Section",
"byPriority": "Priority",
"byDate": "Visit date",
"byName": "Name",
"anyPriority": "All priorities",
"cover": "Cover",
"chooseCover": "Choose cover",
"removeCover": "Remove cover",
"coverError": "Unable to read this photo. Choose a JPG, PNG or WebP image.",
"participants": "Participants",
"addParticipant": "Add participant",
"participantHelp": "Invite a user: they can edit the wishlist only after accepting.",
"editor": "Can edit",
"viewer": "Read only",
"linkHelp": "Anyone with the link can view this wishlist without editing it. No account needed.",
"createLink": "Create link",
"copyLink": "Copy link",
"copied": "Link copied.",
"revokeLink": "Disable link",
"shareLink": "Share link",
"linkUnavailable": "This link is unavailable or has been disabled.",
"noParticipants": "No participants.",
"allowEdit": "Allow editing",
    "subtitle": "Ideas for your next trips, organised your way.",
    "chooseKind": "What would you like to add?",
    "manual": "Add manually",
    "address": "Address",
    "publicTitle": "Wishlists on your public profile",
    "publicHelp": "Select the wishlists to show to profile visitors. All their items will be visible. Deselect them to hide them.",
    "publicEmpty": "Create a wishlist in My world to select it here.",
    "publicShareHint": "You can also show it on your public profile in your profile sharing settings.",
    "restaurant": "Restaurant",
    "country": "Country",
    "priority": "Priority",
    "priorityHelp": "1 highest · 5 lowest",
    "all": "All",
    "search": "Search",
    "searchCountry": "Search countries",
    "noResults": "No results.",
    "editItem": "Edit item",
    "sections": "Sections",
    "items": "items",
    "item": "item",
    "countries": "Countries",
    "cities": "Cities",
    "places": "Places",
    "experiences": "Experiences",
    "restaurants": "Restaurants",
    "countryTrip": "The country will be added as a stop in the itinerary.",
    "empty": "Collect experiences, places, restaurants, cities and countries in each wishlist."
  },
  "es": {
"completion":"Finalización", "inProgressExperiences":"Experiencias en curso", "completedExperiences":"Experiencias completadas",
"doneExperience":"Experiencia completada", "donePlace":"Lugar visitado", "doneRestaurant":"Restaurante visitado", "doneCity":"Ciudad visitada", "doneCountry":"País visitado", "markTodo":"Por hacer",
"filters":"Filtros", "order":"Ordenar", "editWishlist":"Editar wishlist", "inviteIdentifier":"Usuario o correo electrónico",
"copyUnavailable": "El enlace está listo. Pulsa Copiar enlace para copiarlo.",
"declinedOk": "Invitación rechazada.",
"accepted": "Invitación aceptada. Encontrarás la wishlist en Mi mundo.",
"removed": "Participante eliminado. Se le ha enviado una notificación.",
"revokeBody": "¿Eliminar a esta persona de la wishlist? Recibirá una notificación.",
"revokeTitle": "Revocar participación",
"inviteSent": "Invitación enviada. El usuario puede aceptar o rechazar desde la notificación.",
"declined": "Invitación rechazada",
"pending": "Pendiente de aceptación",
"direction": "Dirección",
"descending": "Descendente",
"ascending": "Ascendente",
"editCover": "Modificar portada",
"desiredDate": "Cuándo me gustaría ir",
"clearDate": "Eliminar fecha",
"sort": "Ordenar por",
"bySection": "Sección",
"byPriority": "Prioridad",
"byDate": "Fecha de visita",
"byName": "Nombre",
"anyPriority": "Todas las prioridades",
"cover": "Portada",
"chooseCover": "Elegir portada",
"removeCover": "Eliminar portada",
"coverError": "No se puede leer la foto. Elige una imagen JPG, PNG o WebP.",
"participants": "Participantes",
"addParticipant": "Añadir participante",
"participantHelp": "Invita a un usuario: podrá editar la wishlist solo después de aceptar.",
"editor": "Puede editar",
"viewer": "Solo lectura",
"linkHelp": "Cualquier persona con el enlace puede ver esta wishlist sin editarla. No necesita una cuenta.",
"createLink": "Crear enlace",
"copyLink": "Copiar enlace",
"copied": "Enlace copiado.",
"revokeLink": "Desactivar enlace",
"shareLink": "Compartir enlace",
"linkUnavailable": "Este enlace no está disponible o se ha desactivado.",
"noParticipants": "Sin participantes.",
"allowEdit": "Permitir cambios",
    "subtitle": "Ideas para tus próximos viajes, organizadas a tu manera.",
    "chooseKind": "¿Qué quieres añadir?",
    "manual": "Añadir manualmente",
    "address": "Dirección",
    "publicTitle": "Wishlists en el perfil público",
    "publicHelp": "Selecciona las wishlists que quieres mostrar a los visitantes de tu perfil. Todos sus elementos serán visibles. Desmárcalas para ocultarlas.",
    "publicEmpty": "Crea una wishlist en Mi mundo para seleccionarla aquí.",
    "publicShareHint": "También puedes mostrarla en tu perfil público desde los ajustes para compartir el perfil.",
    "restaurant": "Restaurante",
    "country": "País",
    "priority": "Prioridad",
    "priorityHelp": "1 máxima · 5 mínima",
    "all": "Todo",
    "search": "Buscar",
    "searchCountry": "Buscar un país",
    "noResults": "Sin resultados.",
    "editItem": "Editar elemento",
    "sections": "Secciones",
    "items": "elementos",
    "item": "elemento",
    "countries": "Países",
    "cities": "Ciudades",
    "places": "Lugares",
    "experiences": "Experiencias",
    "restaurants": "Restaurantes",
    "countryTrip": "El país se añadirá como parada en el itinerario.",
    "empty": "Reúne experiencias, lugares, restaurantes, ciudades y países en cada wishlist."
  }
};
const copy = {
 it: {title:"Wishlist",newList:"Nuova Wish List",empty:"Crea una wishlist per raccogliere città, luoghi ed esperienze da fare.",listTitle:"Titolo",description:"Descrizione",icon:"Icona",color:"Colore",newItem:"Aggiungi elemento",emptyList:"Nessun elemento. Aggiungi la prima idea.",name:"Nome",kind:"Tipo",city:"Città",place:"Luogo",experience:"Esperienza",map:"Cerca sulla mappa",save:"Salva",cancel:"Annulla",edit:"Modifica wishlist",share:"Condividi",shared:"Condivisa da",username:"Username Mundely",shareHelp:"L’utente potrà consultare questa wishlist e aggiungere gli elementi ai propri viaggi.",revoke:"Revoca",noShares:"Non ancora condivisa.",remove:"Elimina",deleteTitle:"Elimina wishlist",deleteBody:"La wishlist e i suoi elementi verranno eliminati anche per chi la consulta. I viaggi restano invariati.",deleteItem:"Elimina elemento",deleteItemBody:"Vuoi rimuovere questo elemento dalla wishlist?",error:"Operazione non riuscita. Riprova.",notFound:"Utente non trovato o non disponibile.",addTrip:"Aggiungi a un viaggio",trip:"Viaggio",noTrips:"Non ci sono viaggi modificabili. Crea prima un viaggio.",notes:"Note",time:"Orario",price:"Prezzo",currency:"Valuta",added:"Elemento aggiunto al viaggio.",sharedOk:"Wishlist condivisa.",readOnly:"Puoi consultare questa wishlist e aggiungere gli elementi ai tuoi viaggi.",back:"Tutte le wishlist",position:"Posizione",chooseTrip:"Scegli un viaggio",dates:"Giorni",invalidDates:"Seleziona giorni compresi nelle date del viaggio."},
 en: {title:"Wishlist",newList:"New wishlist",empty:"Create a wishlist for cities, places and experiences you want to explore.",listTitle:"Title",description:"Description",icon:"Icon",color:"Color",newItem:"Add item",emptyList:"No items yet. Add your first idea.",name:"Name",kind:"Type",city:"City",place:"Place",experience:"Experience",map:"Search on the map",save:"Save",cancel:"Cancel",edit:"Edit wishlist",share:"Share",shared:"Shared by",username:"Mundely username",shareHelp:"This user can view the wishlist and add items to their own trips.",revoke:"Revoke",noShares:"Not shared yet.",remove:"Delete",deleteTitle:"Delete wishlist",deleteBody:"The wishlist and its items will be deleted for everyone viewing it. Trips stay unchanged.",deleteItem:"Delete item",deleteItemBody:"Remove this item from the wishlist?",error:"Could not complete the action. Try again.",notFound:"User not found or unavailable.",addTrip:"Add to a trip",trip:"Trip",noTrips:"No editable trips. Create a trip first.",notes:"Notes",time:"Time",price:"Price",currency:"Currency",added:"Item added to the trip.",sharedOk:"Wishlist shared.",readOnly:"You can view this wishlist and add its items to your own trips.",back:"All wishlists",position:"Location",chooseTrip:"Choose a trip",dates:"Days",invalidDates:"Choose days within the trip dates."},
 es: {title:"Wishlist",newList:"Nueva wishlist",empty:"Crea una wishlist con ciudades, lugares y experiencias por descubrir.",listTitle:"Título",description:"Descripción",icon:"Icono",color:"Color",newItem:"Añadir elemento",emptyList:"No hay elementos. Añade tu primera idea.",name:"Nombre",kind:"Tipo",city:"Ciudad",place:"Lugar",experience:"Experiencia",map:"Buscar en el mapa",save:"Guardar",cancel:"Cancelar",edit:"Editar wishlist",share:"Compartir",shared:"Compartida por",username:"Usuario Mundely",shareHelp:"El usuario podrá consultar la wishlist y añadir elementos a sus viajes.",revoke:"Revocar",noShares:"Aún no compartida.",remove:"Eliminar",deleteTitle:"Eliminar wishlist",deleteBody:"La wishlist y sus elementos se eliminarán para todos los que la consultan. Los viajes no cambian.",deleteItem:"Eliminar elemento",deleteItemBody:"¿Eliminar este elemento de la wishlist?",error:"No se pudo completar la operación. Inténtalo de nuevo.",notFound:"Usuario no encontrado o no disponible.",addTrip:"Añadir a un viaje",trip:"Viaje",noTrips:"No hay viajes editables. Crea un viaje primero.",notes:"Notas",time:"Hora",price:"Precio",currency:"Moneda",added:"Elemento añadido al viaje.",sharedOk:"Wishlist compartida.",readOnly:"Puedes consultar esta wishlist y añadir sus elementos a tus viajes.",back:"Todas las wishlists",position:"Ubicación",chooseTrip:"Elige un viaje",dates:"Días",invalidDates:"Elige días dentro de las fechas del viaje."}
};
export function wishlistText(language: string) { const lang=language === "en" || language === "es" ? language : "it";return {...copy[lang],...extra[lang]}; }
